module.exports = __webpack_public_path__ + "assets/img/text-gzh-b80f8338.png";